<template>
  <div class="data-container glass-element">
    <h3 @click="navigateToEvent" class="container-title">
      {{ invitation.inv_event.event_title }}
    </h3>
    <div class="invitation-infos">
      <p>Status: {{ invitation.status | getStatusName }}</p>
      <p >Sent to {{ invitation.invitee.username }}</p>
      <div class="invitations-actions">
        <template>
          <v-btn v-if="invitation.status!='AC' && invitation.status!='HO'" class="accept" @click="updateStatus(true)">Accept</v-btn>
          <v-btn v-if="invitation.status!='RE'" class="refuse" @click="updateStatus()"
            >Refuse
          </v-btn
          >
        </template>
      </div>
      <TinyLoaderLight v-if="loading" />
    </div>
  </div>
</template>

<script>
import TinyLoaderLight from "@/components/atoms/TinyLoaderLight";
import { getStatusName } from "@/utils";

export default {
  components: { TinyLoaderLight },
  props: ["invitation", "send"],
  data() {
    return {
      loading: false,
    };
  },
  filters: {
    getStatusName,
  },
  methods: {
    navigateToEvent() {
      this.$router.push(
        `event/details/${this.invitation.inv_event.event_slug}`
      );
    },
    async updateStatus(accepted) {
      this.loading = true;
      let payload = this.invitation;
      payload['status'] = accepted ? "AC" : "RE";
      payload = this.formatPayload(payload)
      await this.$store.dispatch("updateInvitations", payload);
      this.loading = false;
    },
    async deleteInvitation(invitationId) {
      if (confirm("Delete this invitation ?")) {
        this.loading = true;
        await this.$store.dispatch("deleteInvitation", invitationId);
        this.loading = false;
      }
    },
    async updateInvitations() {
      await this.$store.dispatch("getInvitations");
    },
    formatPayload(payload) {
      payload['invitee'] = payload['invitee']['id']
      payload['inv_event'] = payload['inv_event']['event_id']
      payload['items'] = payload['items'].map(e => e.item_id)
      payload['games'] = payload['games'].map(e => e.item_id)
      return payload;
    }
  },
};
</script>

<style scoped>
h3 {
  cursor: pointer;
}

.invitation-infos {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
}
.invitations-actions {
  width: 320px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.accept {
  background: #9ca7f4 !important;
  color: white !important;
}

.comment {
  background: #ffc800 !important;
  color: #34395e !important;
}

.refuse {
  background: crimson !important;
  color: white !important;
}

@media screen and (max-width: 640px) {
  .invitation-infos {
    flex-direction: column;
  }

  .invitations-actions {
    width: 100%;
    justify-content: space-between !important;
    align-items: center;
    flex-direction: column;
  }
}
</style>
